import { Store } from "pullstate";


export const AccessStore = new Store({
   accessPlan:null
  });